import SuccessFailedDialog from './SuccessFailedDialog';

export default SuccessFailedDialog;
